import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import CopyrightOE from './CopyrightOE'
import QMLogo from '../../static/images/logos/qm_logo.svg'

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  border: 1px solid #ececec;
  border-radius: 16px;
  background-color: #ffffff;
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.07);
  padding: ${props => (props.hideIcon ? '34px' : '65px')} 48px 40px 50px;
`

const QMLogoStyled = styled.div`
  background: url(${QMLogo}) no-repeat;
  height: 78px;
  width: 78px;
  background-size: 100%;
  position: relative;
  right: 50%;
  z-index: 1;
  bottom: 36px;
`

const Outer = styled.div`
  width: 470px;
  margin: 0 auto;
  position: relative;
  top: 120px;
`

const AuthContainer = ({ children, ...props }) => (
  <Outer>
    {!props.hideIcon && (
      <div style={{ position: 'absolute', left: '50%' }}>
        <QMLogoStyled />
      </div>
    )}
    <Container hideIcon={props.hideIcon}>{children}</Container>
    <CopyrightOE />
  </Outer>
)

AuthContainer.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  hideIcon: PropTypes.bool
}

export default AuthContainer



// WEBPACK FOOTER //
// ./src/components/auth/AuthContainer.js